<template>
  <div id="selectpet-occasion" class="mt-2">
    <b-overlay :show="loader" rounded="sm">
      <div class="container mb-3 ">
        <center>
          <h3 for="">
            <strong class="text-danger my-3"></strong>WHAT'S THE OCCASION?
          </h3>
          <span v-if="button" class="pet-select-occasion-error-text text-danger"
            >*Please select an Occasion</span
          >
        </center>
        <label class="wrap my-5 col-md-12">
          <select name="" class="form-control noBorder" v-model="petoccasion">
            <option value="">--Select Occasion--</option>
            <option :value="petoccasion" v-for="petoccasion in petoccasions">{{
              petoccasion.occasion_name
            }}</option>
          </select>
        </label>

        <div class="mt-3 mb-3" slot="modal-footer">
          <div class="row d-flex justify-content-between">
            <div class="col-md-4 ">
              <button class="btn btn-warning col-md-6" @click="prev">
                Previous
              </button>
            </div>
            <div class="col-md-4">
              <button class="btn btn-danger float-right col-md-6" @click="next">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <img
            src="@/assets/site/images/Govava_Wait_icon.gif"
            alt=""
            class=""
          />
          <p id="cancel-label">Please wait...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
export default {
  name: "SelectOccasion",
  props: ["menu", "petData", "species"],
  data() {
    return {
      petoccasions: [],
      petoccasion: "",
      button: false,
      loader: true,
    };
  },
  created() {
    if (this.petoccasions.length < 1) {
      this.getAllOccasions();
    }
  },
  methods: {
    getAllOccasions() {
      this.loader = true;
      var token = localStorage.getItem("userData");
      var userdata_array = JSON.parse(token);
      var api_token = userdata_array.user.api_token;
      var fetch_url = process.env.VUE_APP_URL + "customer/pet/getAllOccasions";
      fetch(fetch_url, {
        method: "post",
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Authorization: "Bearer " + api_token,
        },
        body: JSON.stringify({
          pet_id: this.species.id,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          this.loader = false;
          this.petoccasions = data.allOccasions;
        })
        .catch(function(err) {
          console.log("Fetch Error :-S", err);
        });
    },
    next() {
      if (this.petoccasion == "") {
        this.button = true;
      } else {
        if (this.petData != null) {
          this.$emit("ocasionToPrice", this.petoccasion);
        } else {
          this.$emit("ocasionToImage", this.petoccasion);
        }
      }
    },
    prev() {
      this.$emit("ocasionToName");
    },
  },
};
</script>

<style>
.pet-select-occasion-error-text {
  display: block;
  margin-top: 8px;
  font-size: 16px;
  font-weight: 500;
}
</style>
